"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ESendSmsStatus = void 0;
let ESendSmsStatus = exports.ESendSmsStatus = /*#__PURE__*/function (ESendSmsStatus) {
  ESendSmsStatus["Initial"] = "initial";
  ESendSmsStatus["Loading"] = "loading";
  ESendSmsStatus["Succeed"] = "succeed";
  ESendSmsStatus["Failed"] = "failed";
  return ESendSmsStatus;
}({});